import { useMoonChain } from 'hooks/useMoonChainConfig';
import { useAccount } from 'wagmi';

export function useIsCorrectChainConnected(): boolean {
  const config = useMoonChain();
  const { chain } = useAccount();

  return config.id === chain?.id;
}
